<template>
  <div>
    <DatatableReportV3
      id="coverage-area-table"
      ref="report"
      :source="props.source"
      :config="config"
      :filters="props.filters"
      title="Coverage Areas"
      download-url="/coverage_areas/create_report"
      no-download
    >
      <template #column-zip_code_link="row">
        <span
          @click="editCoverageArea(row, $event)"
          v-html="row.columnValue"
        ></span>
      </template>

      <template #actions>
        <CoverageAreaActions
          @download="downloadReport"
          @add-coverage-area="addCoverageArea"
        />
      </template>
    </DatatableReportV3>
    <CoverageAreaModal
      v-if="isCoverageAreaModalOpen"
      :coverageArea="currentCoverageArea"
      @hide-modal="isCoverageAreaModalOpen = false"
      @save-success="refreshCoverageAreas"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import CoverageAreaActions from "@/CompanyCoverageAreas/CoverageAreaActions.vue";
import CoverageAreaModal from "@/CompanyCoverageAreas/CoverageAreaModal.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import { CoverageArea } from "@/typings/company";

const props = withDefaults(
  defineProps<{ source: string; filters?: Array<{ k: string; v: any }> }>(),
  {
    filters: () => []
  }
);

const config = ref({
  order: [[0, "desc"]],
  responsive: true,
  columns: [
    { data: "zip_code_link", title: "Zip Code", responsivePriority: 1 },
    { data: "city", title: "City", responsivePriority: 2 },
    { data: "state", title: "State", responsivePriority: 3 }
  ]
});

const report = ref();

const isCoverageAreaModalOpen = ref(false);

const currentCoverageArea = ref(null);

function refreshCoverageAreas() {
  report.value.refreshTable();
}

function downloadReport() {
  report.value.exportReport();
}

function addCoverageArea() {
  currentCoverageArea.value = new CoverageArea();
  isCoverageAreaModalOpen.value = true;
}

function editCoverageArea(row, e) {
  e.preventDefault();

  currentCoverageArea.value = row;
  isCoverageAreaModalOpen.value = true;
}
</script>

<style lang="scss" scoped></style>
